import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { SCORE_RANKS } from '../game/gameConfig';

const { FiArrowRight, FiShield, FiTarget, FiZap } = FiIcons;
const LOGO_URL = 'https://media-manager-c.questera.ai/greta-media/f7315b2618eeea0d7624b59aa836285252d672c0343d1c096b331e8c17ecf5d6392c31cbae054d7df53e259ef3b3cc0f/images/aW1hZ2UvanBlZw==/5c90fd6516f7f2702958876fe992eedb.jpg';

function LandingScreen({ onStart, starting, trackingError }) {
  return (
    <main className="landing-screen">
      <div className="ink-orb ink-orb-one" />
      <div className="ink-orb ink-orb-two" />

      <motion.section
        className="hero-copy"
        initial={{ opacity: 0, x: -28 }}
        animate={{ opacity: 1, x: 0 }}
      >
        <div hidden>
          <img className="event-logo" src={LOGO_URL} alt="MPESPORT 時代德毅能體育會" />
        </div>
        <span className="eyebrow">10.03 · GREATER BAY AREA WING CHUN CULTURAL PLAZA</span>
        <h1>
          大灣區詠春家
          <span>文化廣場 2026</span>
        </h1>
        <p className="hero-subtitle">10 月 3 日，從詠春千人匯演到詠春嘉年華，<br />以互動闖關感受傳承力量。</p>

        <section className="score-preview" aria-labelledby="score-preview-title">
          <div className="score-preview-heading">
            <strong id="score-preview-title">挑戰成就</strong>
            <span>三關累積總分，連擊越高得分越多</span>
          </div>
          <div className="score-preview-grid">
            {SCORE_RANKS.map((rank) => (
              <div className="score-preview-item" key={rank.title}>
                <small>{rank.level}</small>
                <strong>{rank.title}</strong>
                <span>{rank.range} 分</span>
              </div>
            ))}
          </div>
        </section>

        <button className="primary-button" type="button" onClick={onStart} disabled={starting}>
          <span>{starting ? '正在登記挑戰…' : '開始文化闖關'}</span>
          <SafeIcon icon={FiArrowRight} />
        </button>

        {trackingError && (
          <p className="tracking-error" role="alert">
            本次記錄暫未成功寫入，遊戲仍可正常進行。
          </p>
        )}

        <p className="micro-copy">約 90 秒完成 · 手機及平板觸控操作</p>
      </motion.section>

      <motion.section
        className="hero-visual"
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.15 }}
      >
        <div className="center-line" />
        <div hidden>
          <div className="fighter">
            <div className="fighter-head" />
            <div className="fighter-body" />
            <div className="fighter-arm fighter-arm-left" />
            <div className="fighter-arm fighter-arm-right" />
          </div>
        </div>
        <div className="wooden-dummy">
          <span className="dummy-arm arm-one" />
          <span className="dummy-arm arm-two" />
          <span className="dummy-arm arm-three" />
        </div>
        <div className="date-stamp">
          <strong>10</strong>
          <span>月</span>
          <strong>03</strong>
        </div>
      </motion.section>

      <div className="principles">
        <span><SafeIcon icon={FiShield} /> 詠春千人匯演</span>
        <span><SafeIcon icon={FiTarget} /> 詠春嘉年華</span>
        <span><SafeIcon icon={FiZap} /> 10 月 3 日</span>
      </div>
    </main>
  );
}

export default LandingScreen;